"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isLoadingSelector = exports.couponsErrorSelector = exports.usersCouponMetadataSelector = exports.usersCouponDataSelector = exports.couponsMetadataSelector = exports.couponDataSelector = exports.couponsDataSelector = void 0;

var _reselect = require("reselect");

var couponsSelector = function couponsSelector(state) {
  return state.coupons;
};

var couponsDataSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.data;
});
exports.couponsDataSelector = couponsDataSelector;
var couponDataSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.coupon;
});
exports.couponDataSelector = couponDataSelector;
var couponsMetadataSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.metadata;
});
exports.couponsMetadataSelector = couponsMetadataSelector;
var usersCouponDataSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.usersCoupon.data;
});
exports.usersCouponDataSelector = usersCouponDataSelector;
var usersCouponMetadataSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.usersCoupon.metadata;
});
exports.usersCouponMetadataSelector = usersCouponMetadataSelector;
var couponsErrorSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.error;
});
exports.couponsErrorSelector = couponsErrorSelector;
var isLoadingSelector = (0, _reselect.createSelector)(couponsSelector, function (coupons) {
  return coupons.isLoading;
});
exports.isLoadingSelector = isLoadingSelector;
var _default = {
  couponsDataSelector: couponsDataSelector,
  couponDataSelector: couponDataSelector,
  couponsMetadataSelector: couponsMetadataSelector,
  usersCouponDataSelector: usersCouponDataSelector,
  usersCouponMetadataSelector: usersCouponMetadataSelector,
  couponsErrorSelector: couponsErrorSelector,
  isLoadingSelector: isLoadingSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map